import React, { useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';

import { upload_photo, attach_photo_to_node } from 'helpers/backend';

const thumbsContainer = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

const thumb = {};

const thumbInner = {
  overflow: 'hidden',
};

const img = {
  display: 'block',
  width: 'auto',
  maxHeight: '150px',
};

const dropZone = {
  border: '2px dashed rgb(66, 65, 61)',
  borderRadius: '10px',
  padding: '15px',
  backgroundColor: 'rgba(255, 255, 255, 0.83)',
  cursor: 'pointer',
};

const dropZoneCaption = {
  fontSize: '0.8rem',
};

const fontSml = {
  fontSize: '0.8rem',
};

function ImageDropzone(props) {
  const nid = props.nid;
  const field = props.field;
  const title = props.title;
  const desc = props.desc;
  const [files, setFiles] = useState([]);
  const { getRootProps, getInputProps } = useDropzone({
    accept: 'image/jpeg, image/png, image/jpg',
    multiple: false,
    onDrop: acceptedFiles => {
      const reader = new FileReader();
      reader.readAsArrayBuffer(acceptedFiles[0]);
      reader.onloadend = function() {
        var result = reader.result;
        var fileName = acceptedFiles[0].name.replace(/\s+/g, '');
        var saveFileAs = Date.now() + '_' + fileName;
        upload_photo(saveFileAs, reader.result, field, nid).then(res => {
          attach_photo_to_node(nid, field, res.data.fid[0].value);
          props.uploaded(field);
        });
      };
      setFiles(
        acceptedFiles.map(file =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        )
      );
    },
  });

  const thumbs = files.map(file => (
    <div style={thumb} key={file.name}>
      <div style={thumbInner}>
        <img alt="" src={file.preview} style={img} className="w-100" />
      </div>
    </div>
  ));

  useEffect(
    () => () => {
      // Make sure to revoke the data uris to avoid memory leaks
      files.forEach(file => URL.revokeObjectURL(file.preview));
    },
    [files]
  );

  return (
    <div className="col-6 col-lg-3 mb-4 mb-lg-0">
      <p className="font-weight-bold mb-0">{title}</p>
      <p style={fontSml}>{desc}</p>
      <div {...getRootProps({ className: 'dropzone' })} style={dropZone}>
        <input {...getInputProps()} />
        {files == 0 && (
          <p className="m-0" style={dropZoneCaption}>
            Drag n drop a file here, or click to select
          </p>
        )}
        {files != 0 && <div style={thumbsContainer}>{thumbs}</div>}
      </div>
    </div>
  );
}

export default ImageDropzone;
